import toastr from "toastr";

export function showMessageBox(pMessage, pLevel, pOptions) {
  if (undefined == toastr.options || Object.keys(toastr.options).length === 0) {
    toastr.options = {
      closeButton: true,
      positionClass: "toast-top-center",
      preventDuplicates : true
    };
  }

  switch (pLevel) {
    case undefined:
    case 'info': toastr.info(pMessage, undefined, pOptions); break;
    case 'warning': toastr.warning(pMessage, undefined, pOptions); break;
    case 'error': toastr.error(pMessage, undefined, pOptions); break;
    case 'success': toastr.success(pMessage, undefined, pOptions); break;
  }
}
